var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useTeamAccountPlanDetailsQuery } from './useTeamAccountPlanDetailsQuery';
import { useGetCompletedTeamAccountOnboardingStepsQuery } from '../SelfServe/Onboarding/useGetCompletedOnboardingStepsQuery';
var defaultOnboardingValue = {
    showQuickSetupSuccess: false,
    setShowQuickSetupSuccess: function () { },
};
var defaultValue = {
    teamAccountPlan: null,
    hasMaxBudgetsLimit: false,
    hasMaxMembersLimit: false,
    hasMaxAddPaymentMethodMonthlyLimit: false,
    hasMaxBudgetAmountLimit: false,
    maxBudgetsLimit: null,
    maxMembersLimit: null,
    maxAddPaymentMethodLimit: null,
    maxBudgetAmountLimit: null,
    onboarding: defaultOnboardingValue,
};
var TeamAccountConfigurationContext = React.createContext(defaultValue);
export var getLimitationsByLimitationType = function (data) {
    var limitationsByLimitationType = data === null || data === void 0 ? void 0 : data.teamAccountPlanDetails.planLimitations.reduce(function (accumulator, currentValue) {
        accumulator[currentValue.type] = currentValue;
        return accumulator;
    }, {});
    return limitationsByLimitationType;
};
var TeamAccountConfigurationProvider = function (props) {
    var _a = useTeamAccountPlanDetailsQuery(props.teamAccountId), data = _a.data, teamAccountPlanRefetch = _a.refetch;
    var onboardingRefetch = useGetCompletedTeamAccountOnboardingStepsQuery(props.teamAccountId).refetch;
    var _b = getLimitationsByLimitationType(data) || {}, maxBudgetAmountLimit = _b.MAX_BUDGET_AMOUNT, maxBudgetsLimit = _b.MAX_BUDGETS_PER_TEAM_ACCOUNT, maxAddPaymentMethodLimit = _b.MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY, maxMembersLimit = _b.MAX_MEMBERS_PER_TEAM_ACCOUNT;
    var _c = __read(React.useState(false), 2), showQuickSetupSuccess = _c[0], setShowQuickSetupSuccess = _c[1];
    React.useEffect(function () {
        setShowQuickSetupSuccess(false);
    }, [props.teamAccountId]);
    var value = {
        teamAccountPlan: data === null || data === void 0 ? void 0 : data.teamAccountPlanDetails.plan,
        hasMaxBudgetsLimit: Boolean(maxBudgetsLimit === null || maxBudgetsLimit === void 0 ? void 0 : maxBudgetsLimit.limit),
        hasMaxMembersLimit: Boolean(maxMembersLimit === null || maxMembersLimit === void 0 ? void 0 : maxMembersLimit.limit),
        hasMaxAddPaymentMethodMonthlyLimit: Boolean(maxAddPaymentMethodLimit === null || maxAddPaymentMethodLimit === void 0 ? void 0 : maxAddPaymentMethodLimit.limit),
        hasMaxBudgetAmountLimit: Boolean(maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit),
        maxBudgetsLimit: maxBudgetsLimit,
        maxMembersLimit: maxMembersLimit,
        maxAddPaymentMethodLimit: maxAddPaymentMethodLimit,
        maxBudgetAmountLimit: maxBudgetAmountLimit,
        onboarding: {
            showQuickSetupSuccess: showQuickSetupSuccess,
            setShowQuickSetupSuccess: setShowQuickSetupSuccess,
            reloadCompletedOnboardingSteps: onboardingRefetch,
        },
        reloadTeamAccountPlanDetails: teamAccountPlanRefetch,
    };
    return (React.createElement(TeamAccountConfigurationContext.Provider, { value: value }, props.children));
};
var useTeamAccountConfigurationContext = function () {
    var context = React.useContext(TeamAccountConfigurationContext);
    return context;
};
var useOnboardingContext = function () {
    var context = React.useContext(TeamAccountConfigurationContext);
    return context.onboarding;
};
export { TeamAccountConfigurationProvider, useTeamAccountConfigurationContext, useOnboardingContext, };
